import { render, staticRenderFns } from "./AdminTagList.vue?vue&type=template&id=43ffbbde"
import script from "./AdminTagList.vue?vue&type=script&lang=js"
export * from "./AdminTagList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports